export default __webpack_public_path__ + "static/media/logo165x90white.8038a3ad.png";